import React, { useState } from 'react';
import { StyledMoreBlocks } from '../Styled/StyledMore';
import { IAsset, MIN_SCREEN_SIZE_FOR_MORE_ITEMS } from '../../constants/assets';
import { getVideoId } from '../../utils';
import { VideoModal } from '../Modal/VideoModal';
import { MoreItem } from './MoreItem';
import { AssetsCarousel } from '../AssetsCarousel';
import { useWindowSize } from '../../hooks/useWindowSize';

interface MoreInterface {
  assets: IAsset[];
}

export const More = (props: MoreInterface): JSX.Element => {
  const { assets } = props;

  const size = useWindowSize();

  const [showModal, setShowModal] = useState(false);
  const [selectedAsset, setAsset] = useState<IAsset>({
    type: 'Video',
    title: '',
    description: '',
    thumbnail: '',
    stages: ['Early'],
    links: {
      self: 'self/id',
    },
  });

  const handleShowVideo = (asset: IAsset) => {
    setAsset(asset);
    setShowModal(true);
  };

  return (
    <>
      <StyledMoreBlocks data-testid="more">
        {assets.length <= 4 && size.width >= MIN_SCREEN_SIZE_FOR_MORE_ITEMS ? (
          assets.map((asset: IAsset, index: number) => (
            <MoreItem key={index} asset={asset} onShowVideo={handleShowVideo} />
          ))
        ) : (
          <AssetsCarousel assets={assets} handleShowVideo={handleShowVideo} windowWidth={size.width} />
        )}
      </StyledMoreBlocks>
      <VideoModal id={getVideoId(selectedAsset.links.self)} showModal={showModal} setShowModal={setShowModal} />
    </>
  );
};
